module.exports = __webpack_public_path__ + "static/empty-states-buttons-do-7506ae1839e9f646e9b6483f8a027c05.png";